import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { createReactToastifyAdapter, DAppStateProvider as SharedDAppStateProvider, useDAppState, } from '@cai/shared/dapp';
import { toast } from 'react-toastify';
import { useAuth } from '../hooks/useAuth';
import { useTransactionHistory } from '../hooks/useTransactionHistory';
import NftServices from '../services/nft.service';
import AuthServices from '../services/auth.service';
import cookies from '../utils/cookies';
const dappToast = createReactToastifyAdapter(toast);
export { dappToast };
export const DAppStateProvider = ({ children }) => {
    const { verifyAccessToken, connectToWallet, disconnectWallet, store: { user, accessTokenVerified, status: loginStatus }, } = useAuth();
    const { history: txHistory, fetchForWallet, create: createTxHistory, update: updateTxHistory, patchStatus: patchTxStatus, clearAll: clearTxHistory, } = useTransactionHistory();
    const txHistoryRef = useRef(txHistory);
    txHistoryRef.current = txHistory;
    const walletSession = useMemo(() => ({
        user,
        accessTokenVerified,
        loginStatus,
        getWalletChallenge: (body) => AuthServices.getWalletChallenge(body),
        connectToWallet: (body) => connectToWallet(body),
        disconnectWallet: async () => {
            await disconnectWallet();
        },
        verifyAccessToken: () => verifyAccessToken(),
    }), [user, accessTokenVerified, loginStatus, connectToWallet, disconnectWallet, verifyAccessToken]);
    const createNftUris = useCallback(async (nfts, chain) => (await NftServices.createUris(nfts, chain)).data, []);
    const transactionHistory = useMemo(() => ({
        get history() {
            return txHistoryRef.current;
        },
        hasAuthToken: () => Boolean(cookies.get('accessToken')),
        createTransaction: async (body) => {
            const result = await createTxHistory(body);
            return { tx: result?.tx };
        },
        updateTransaction: async (id, body) => {
            await updateTxHistory(id, body);
        },
        fetchForWallet: async (params) => {
            await fetchForWallet(params);
        },
        patchTransactionStatus: (payload) => {
            patchTxStatus(payload);
        },
        clearAll: () => {
            clearTxHistory();
        },
    }), [createTxHistory, updateTxHistory, fetchForWallet, patchTxStatus, clearTxHistory]);
    useEffect(() => {
        if (user?._id && user?.walletAddress && loginStatus === 'success') {
            fetchForWallet({ walletAddress: user.walletAddress });
        }
    }, [user?._id, user?.walletAddress, loginStatus, fetchForWallet]);
    return (_jsx(SharedDAppStateProvider, { toast: dappToast, linkedWalletAddress: user?.walletAddress, createNftUris: createNftUris, walletSession: walletSession, transactionHistory: transactionHistory, children: children }));
};
export { useDAppState };
